<template>
  <div class="store-app-wrapper">

    <div class="custom-wrapper op-wrapper"
      v-if="hasRes('store_app_add')" >
      <el-button
        type="danger"
        size="medium"
        @click="addStoreAppDialogVisible = true">添加应用</el-button>
    </div>

    <store-app-filter
      v-if="hasRes('store_app_index')"
      @filter="updateTableData" />

    <!--应用列表-->
    <div class="app-list custom-wrapper"
      v-if="appList.length > 0 && hasRes('store_app_index')">
      <div
        class="app"
        v-for="app in appList"
        :key="app.app_store_id">
        <el-card>
          <div slot="header" class="clearfix">
            <span>{{ app.app_name_i18n[0].name }}</span>
            <span style="float: right;">{{ app.app_store_id }}</span>
          </div>

          <div class="app-info">
            <div class="label-info">
              <p>应用分类:</p>
              <el-tag
                type="danger"
                size="mini">
                <p>{{ app.app_category_detail.app_category_name_i18n[0].name }}</p>
              </el-tag>
            </div>

            <div class="label-info">
              <p>应用套餐:</p>
              <el-tooltip placement="top">
                <div slot="content">
                  <p style="margin: 0">
                   套餐名, 市场价, 折扣价, 套餐时长
                  </p>
                  <p
                    style="margin: 0;"
                    v-for="pac in app.package"
                    :key="pac.name">
                  {{ pac.name }}, {{ pac.market_price }}, {{ pac.discount_price }}, {{ formatExpiredTime(pac.duration) }}
                  </p>
                </div>
                <p>{{ app.package.length }}个</p>
              </el-tooltip>
            </div>

            <div class="label-info">
              <p>是否公开:</p>
              <el-tag
                type="danger"
                size="mini">
                <p>{{ app.is_publish ? '公开' : '不公开' }}</p>
              </el-tag>
            </div>
          </div>

          <p class="intro">{{ app.intro }}</p>

          <div class="app-op"
            v-if="hasRes('store_app_edit') || hasRes('store_app_delete')">
            <el-button
              type="text"
              :disabled="isBaseApp(app)"
              v-if="hasRes('store_app_edit')"
              @click="onAppEditClick(app)">修改</el-button>
            <el-button
              type="text"
              class="danger-text"
              :disabled="isBaseApp(app)"
              v-if="hasRes('store_app_delete')"
              @click="onAppDeleteClick(app)">删除</el-button>
          </div>
        </el-card>
      </div>

    </div>

    <div
      class="custom-wrapper"
      style="display: flex;
        justify-content: center;
        padding: 20px 0;
        color: #909399;"
      v-else>
      暂无数据
    </div>

    <custom-paginate
      :count="appCount"
      v-if="hasRes('store_app_index')"
      @page-change="updateTableData" />

    <dialog-add-store-app
      @data-change="updateTableData"
      v-if="hasRes('store_app_add')"
      :visible.sync="addStoreAppDialogVisible" />

    <dialog-edit-store-app
      @data-change="updateTableData"
      :editing-app="editingApp"
      v-if="hasRes('store_app_edit')"
      :visible.sync="editStoreAppDialogVisible" />

  </div>
</template>

<script>
import CustomPaginate from '@/components/CustomPaginate'
import StoreAppFilter from './components/StoreAppFilter'
import DialogAddStoreApp from './components/DialogAddStoreApp'
import DialogEditStoreApp from './components/DialogEditStoreApp'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_PAGE_SIZE, SET_LOADING } from '@/store/modules/table'

export default {
  name: 'StoreApp',
  components: {
    CustomPaginate,
    StoreAppFilter,
    DialogAddStoreApp,
    DialogEditStoreApp
  },
  data () {
    return {
      addStoreAppDialogVisible: false,

      editStoreAppDialogVisible: false,
      editingApp: {},

      baseAppIdList: [
        1001, 1002, 1003, 1004, 1005, 1006,
        1007, 1008, 1009, 1010, 1011, 1012,
        1013, 1014, 1015, 1016, 1017, 1018,
        1019, 1020, 1021
      ]
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'filters'
    ]),
    ...mapState('store', [
      'appList',
      'appCount'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_PAGE_SIZE,
      SET_LOADING
    ]),
    ...mapActions('store', [
      'getApps',
      'deleteApp'
    ]),

    // 是否基础应用
    isBaseApp (app) {
      return this.baseAppIdList.indexOf(app.app_store_id) !== -1
    },

    formatExpiredTime (time) {
      if (time === 3153600000) {
        return '永久'
      } else {
        const day = (time / 86400).toFixed(2)
        return `${day}天`
      }
    },

    onAppEditClick (app) {
      this.editingApp = app
      this.editStoreAppDialogVisible = true
    },
    async onAppDeleteClick (app) {
      try {
        await this.$confirm(
          '此操作将永久删除应用，是否继续？', '删除应用',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteApp({
          app_store_id: app.app_store_id
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    async updateTableData () {
      if (!this.hasRes('store_app_index')) return

      this.setLoading(true)

      try {
        await this.getApps({
          page: this.page,
          pageSize: this.pageSize,
          condition: this.filters
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取应用列表失败'
        })
      }
      this.setLoading(false)
    }
  },
  mounted () {
    this.setPage(1)
    this.setPageSize(8)
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/base.scss';

.store-app-wrapper {

  .op-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .app-list {
    display: flex;
    justify-content: space-start;
    align-items: center;
    flex-flow: row wrap;

    .app {
      width: 23%;
      padding: 10px;

      .app-info {

        .label-info {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        p {
          line-height: 1.5;
          margin: 0;
        }
      }

      .intro {
        height: 38px;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .app-op {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/StoreApp.vue